<template lang="pug">
v-dialog(v-model="show", :max-width="mobile ? '95%' : '50%'", v-if="fatura", )
  v-flex(lg12, style="border-radius:25px;")
    v-card.elevation-1
      v-card-title
        v-layout(row, wrap)
          v-flex.md6.xs12
            h4.font-weight-bold(style="font-size: 18px; color:#1113128A") Fatura - {{$dayjs(fatura.data_referencia).format('MMMM [de] YYYY') }}
              br
              small.font-weight-regular {{$dayjs(fatura.data_inicio).format('DD/MM/YYYY')}} - {{$dayjs(fatura.data_fim).format('DD/MM/YYYY')}}
          v-flex.md6.xs12.text-md-right
            v-chip(small,:style="{'color':$root.getStatusFatura(fatura).color,'background':$root.getStatusFatura(fatura).backgroundcolor}").font-weight-bold {{$root.getStatusFatura(fatura).label.toUpperCase()}}
      v-card-text
        template
          div
            h4.pt-3(style="font-size:22px; color:#1113128A; font-weight:500") Cálculo do Repasse ou Boleto
            div(style="background-color:#FAFAFA; border-radius:8px").pa-3.mt-4.mb-4
              v-layout(row,wrap, v-if="fatura.indicadores && (fatura.indicadores.quantidadePedidosPgtOnline || !estabelecimentoSelecionado.cardapio_digital)").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Valor líquido de
                  strong  {{(fatura.indicadores ? fatura.indicadores.quantidadePedidosPgtOnline : 0)}} vendas confirmadas com pagamento online
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                  strong + {{(fatura.indicadores ? fatura.indicadores.totalLiquidoVendasPgtOnline : 0) | currency}}

              v-layout(row, wrap, v-if="!estabelecimentoSelecionado.cardapio_digital").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Reembolso dos incentivos usados em <strong> {{' ' + (fatura.indicadores ? fatura.indicadores.quantidadeReembolsosPromocionais + fatura.indicadores.quantidadeDescontos : 0)}} vendas</strong>
                  v-icon(@click="openHelperIncentivos(fatura)", v-if="(fatura.indicadores.quantidadeReembolsosPromocionais + fatura.indicadores.quantidadeDescontos) > 0").clicable.pl-2 info
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                  strong + {{ (fatura.indicadores ? fatura.indicadores.totalReembolsosPromocionais + fatura.indicadores.totalDescontos : 0) | currency }}

              v-layout(row, wrap, v-if="fatura.indicadores && fatura.indicadores.quantidadeTaxaServicoPgtOnline").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Valor das <strong>taxas de serviço</strong> advindas de <strong>{{ fatura.indicadores ? fatura.indicadores.quantidadeTaxaServicoPgtOnline : 0 }} vendas confirmadas com pagamento online</strong>
                  br
                  small(style="font-size:16px; color:#1113128A") (valor pago pelo cliente e repassado para a plataforma)
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                  strong + {{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoPgtOnline : 0 ) | currency }}

              v-layout(row, wrap, v-if="fatura.totalSaldoRemanescenteRepasse").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Saldo remanescente
                  br
                  small(style="font-size:16px; color:#1113128A") (valores de repasse retidos no mês anterior)
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                  strong + {{ fatura.totalSaldoRemanescenteRepasse | currency }}

              v-layout(row,wrap, v-if="estabelecimentoSelecionado && !estabelecimentoSelecionado.cardapio_digital").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Comissão
                  v-icon(@click="openHelperComissao(fatura)").clicable.pl-2 info
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC", v-if="(fatura.indicadores ? fatura.indicadores.totalComissao : 0) > 0")
                  strong - {{(fatura.indicadores ? fatura.indicadores.totalComissao : 0) | currency}}
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641", v-if="(fatura.indicadores ? fatura.indicadores.totalComissao : 0) <= 0")
                  strong + {{Math.abs(fatura.indicadores ? fatura.indicadores.totalComissao : 0) | currency}}

              v-layout(row,wrap, v-if="fatura.indicadores && fatura.totalSaldoRemanescenteFatura").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Débitos remanescentes
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC", v-if="fatura.totalSaldoRemanescenteFatura > 0")
                  strong - {{fatura.totalSaldoRemanescenteFatura | currency}}
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641", v-if="fatura.totalSaldoRemanescenteFatura <= 0")
                  strong + {{Math.abs(fatura.totalSaldoRemanescenteFatura) | currency}}

              v-layout(row,wrap, v-if="fatura.indicadores && (fatura.indicadores.quantidadePedidosPgtOnline || (estabelecimentoSelecionado && !estabelecimentoSelecionado.cardapio_digital))").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Taxa do pagamento online
                  v-icon(@click="openHelperTaxasPgtOnline(fatura,'pgtonline')").clicable.pl-2 info
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                  strong - {{(fatura.indicadores ? fatura.indicadores.totalTaxasPgtOnline : 0) | currency}}

              v-layout(row,wrap, v-if="fatura.totalTaxaAntecipacao && (fatura.indicadores && (fatura.indicadores.quantidadePedidosPgtOnline || (estabelecimentoSelecionado && !estabelecimentoSelecionado.cardapio_digital)))").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Taxa de antecipação
                  v-icon(@click="openHelperTaxasPgtOnline(fatura,'antecipacao')").clicable.pl-2 info
                  br(v-if="!fatura.id")
                  small(style="font-size:16px; color:#1113128A", v-if="!fatura.id") (taxa cobrada apenas se a antecipação for solicitada)
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                  strong - {{fatura.totalTaxaAntecipacao | currency}}

              v-layout(row,wrap, v-if="fatura.indicadores && (fatura.indicadores.quantidadePedidosPgtOnline || (estabelecimentoSelecionado && !estabelecimentoSelecionado.cardapio_digital))").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Taxa de transferência
                  br
                  small(style="font-size:16px; color:#1113128A", v-if="fatura.quantidadeRepassesEfetivos>1") (taxa referente à {{fatura.quantidadeRepassesEfetivos}} repasses)
                v-flex.md4.xs12.text-md-right(style="font-size:18px;")
                  strong(style="color:#111312CC") - {{(fatura.totalTED || 0) | currency}}

              v-layout(row,wrap, v-if="fatura.indicadores && fatura.indicadores.totalTaxaServicoLiquida").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label Taxa de serviço
                  v-icon(@click="openHelperTaxaServico(fatura)").clicable.pl-2 info
                v-flex.md4.xs12.text-md-right(style="font-size:18px;")
                  strong(style="color:#111312CC") - {{ (fatura.indicadores ? fatura.indicadores.totalTaxaServicoLiquida : 0 ) | currency }}

              v-layout(row,wrap, v-for="(aditivo, index) in fatura.aditivos", :key="index").pb-4
                v-flex.md8.xs12(style="font-size:18px; color:#111312CC")
                  label {{ aditivo.descricao }}
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC", v-if="aditivo.valor > 0")
                  strong - {{aditivo.valor | currency}}
                v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641", v-if="aditivo.valor < 0")
                  strong + {{(Math.abs(aditivo.valor)) | currency}}

          div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="!fatura.totalBoletosEfetivos && fatura.totalRepasses").pa-3.mt-4.mb-4
            v-layout(row, wrap)
              v-flex.md8.xs12(style="font-size:18px; color:#111312")
                strong Repasse
              v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                strong {{fatura.totalRepasses | currency}}

          div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.totalBoletosEfetivos > 0").pa-3.mt-4.mb-4
            v-layout(row, wrap)
              v-flex.md8.xs12(style="font-size:18px; color:#111312")
                strong Boleto
              v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#111312CC")
                strong - {{fatura.totalBoletosEfetivos | currency}}

          div(style="border:1px solid; border-radius:8px; color:#0000000A", v-if="fatura.totalBoletosEfetivos < 0").pa-3.mt-4.mb-4
            v-layout(row, wrap)
              v-flex.md8.xs12(style="font-size:18px; color:#111312")
                strong Reembolso
              v-flex.md4.xs12.text-md-right(style="font-size:18px; color:#0F7641")
                strong + {{Math.abs(fatura.totalBoletosEfetivos) | currency}}

          div(v-if="fatura.repasse")
            messagePanel(
              ref="message",
              :title="`Antecipação ${fatura.repasse.valor >= $root.enums.VALOR_MINIMO_REPASSE ? 'disponível' : 'indisponível'}`",
              :message="getMessageAntecipacao(fatura)",
              :cta="getCTAAntecipacao(fatura)",
              :type="fatura.repasse.valor >= $root.enums.VALOR_MINIMO_REPASSE ? 'info' : 'warning'",
              v-if="!fatura.id && fatura.antecipada && fatura.repasse.status == $root.enums.STATUS.REPASSE_AGUARDANDO && !$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO"
            )

            messagePanel(
              ref="message",
              :title="getMessageRepasse(fatura.repasse).title",
              :message="getMessageRepasse(fatura.repasse).message",
              :type="getMessageRepasse(fatura.repasse).type",
              :cta="getMessageRepasse(fatura.repasse).cta",
              v-if="fatura.id && fatura.repasse.valor > 0"
            )

      v-card-actions.mr-4.pb-3
        v-spacer
        v-btn(flat, type="button", @click="close()") Fechar

  helperComissao(ref="dialogHelperComissao")
  helperTaxaServico(ref="dialogHelperTaxaServico")
  helperPgtOnline(ref="dialogHelperPgtOnline")
  antecipacao(ref="dialogAntecipacao")
  helperIncentivos(ref="dialogHelperIncentivos")
  DialogComprovante(ref="dialogComprovante")

</template>

<script>

import helperComissao from '@/pages/financeiro/fatura/HelperComissao';
import helperTaxaServico from '@/pages/financeiro/fatura/HelperTaxaServico';
import helperPgtOnline from '@/pages/financeiro/fatura/HelperTaxasPgtOnline';
import helperIncentivos from '@/pages/financeiro/fatura/HelperIncentivos';
import antecipacao from '@/pages/financeiro/fatura/Antecipacao';
import messagePanel from '@/components/MessagePanel';
import DialogComprovante from '@/pages/financeiro/fatura/DialogComprovante';

export default {
  components: {
    antecipacao,
    messagePanel,
    helperComissao,
    helperTaxaServico,
    helperPgtOnline,
    helperIncentivos,
    DialogComprovante
  },
  data () {
    return {
      show: false,
      fatura: null,
      mobile: null,
    }
  },
  created () {
    if (process.browser) {
      window.addEventListener("resize", this.checkScreen);
      this.checkScreen();
    }
  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  methods: {
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 960) {
        this.mobile = true;
        return;
      }
      this.mobile = false;
      return;
    },
    getMessageAntecipacao(fatura){
      const vm = this;
      if (fatura.repasse.valor >= vm.$root.enums.VALOR_MINIMO_REPASSE) {
        return "Você poderá antecipar os valores a receber referentes aos pedidos do dia "+vm.$dayjs(fatura.data_inicio).format('DD/MM/YYYY')+" até dia "+vm.$dayjs(fatura.data_fim).format('DD/MM/YYYY');
      }
      return 'Não é possível realizar repasses com valores inferiores a '+vm.$options.filters.currency(vm.$root.enums.VALOR_MINIMO_REPASSE)+'.'
    },
    getCTAAntecipacao(fatura){
      const vm = this;
      if (fatura.repasse.valor >= vm.$root.enums.VALOR_MINIMO_REPASSE) {
        return {
          text: "Solicitar antecipação",
          action: function () {
            vm.$refs.dialogAntecipacao.open(fatura);
          }
        }
      }
      return null
    },
    validarDataRepasse(data_repasse) {
      if (!data_repasse) return false;
      const dataRepasse = this.$dayjs(data_repasse);
      const dataAtual = this.$dayjs();
      const diferencaDias = dataAtual.diff(dataRepasse, 'day');
      return diferencaDias <= 60;
    },
    getMessageRepasse(repasse){
      const vm = this;
      const enums = vm.$root.enums;
      const msg = {};
      msg[enums.STATUS.REPASSE_REALIZADO] = {
        title: "Repasse realizado",
        message: "A transferência foi realizada em "+vm.$dayjs(repasse.data_pagamento).format('DD/MM/YYYY'),
        cta: vm.$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO ? null : {
          text: "Ver comprovante",
          action: function () {
            if (vm.validarDataRepasse(repasse.data_repasse)) window.open(repasse.comprovante, '_blank');
            else vm.$refs.dialogComprovante.open(repasse);
          }
        },
        type: "success"
      };
      msg[enums.STATUS.REPASSE_AGUARDANDO] = {
        title: "Repasse pendente",
        message: "A transferência será realizada em "+vm.$dayjs(repasse.data_repasse).format('DD/MM/YYYY'),
        type: "warning"
      };
      msg[enums.STATUS.REPASSE_ERRO] = {
        title: "Repasse com erro",
        message: repasse.descricao_status,
        type: "danger"
      };
      msg[enums.STATUS.SALDO_REMANESCENTE] = {
        title: "Repasse retido",
        message: 'Não é possível realizar repasses com valores inferiores à '+vm.$options.filters.currency(enums.VALOR_MINIMO_REPASSE)+'. Este valor será acumulado para o próximo repasse.',
        type: "warning"
      };
      return msg[repasse.status];
    },
    openHelperComissao(fatura){
      const vm = this;
      vm.$refs.dialogHelperComissao.open(fatura);
    },
    openHelperTaxaServico(fatura){
      const vm = this;
      vm.$refs.dialogHelperTaxaServico.open(fatura);
    },
    openHelperTaxasPgtOnline(fatura, tipo){
      const vm = this;
      vm.$refs.dialogHelperPgtOnline.open(fatura, tipo);
    },
    openHelperIncentivos(fatura){
      const vm = this;
      vm.$refs.dialogHelperIncentivos.open(fatura);
    },
    open (fatura){
      const vm = this;
      vm.fatura = fatura;
      vm.show = true;
    },
    close(){
      const vm = this;
      vm.fatura = null;
      vm.show = false;
    }
  }
}
</script>

<style scoped>
  .clicable {
    color:#0F7641;
    cursor:pointer;
  }
</style>
